// src/client/components/Logo.tsx
// Three horizontal Cobalt bars stacked vertically. Top→bottom uses the lighter→
// darker primary ramp (300 / 500 / 700). Sizes scale proportionally; the
// 32px size is used for the PWA icon.
import styles from './Logo.module.css';

interface Props {
  size?: 24 | 32 | 48 | 64 | 96;
  ariaLabel?: string;
}

export default function Logo({ size = 48, ariaLabel = 'Thandizo' }: Props) {
  return (
    <div
      className={styles.logo}
      role="img"
      aria-label={ariaLabel}
      style={{ width: size, height: size }}
    >
      <span className={`${styles.bar} ${styles.bar1}`} />
      <span className={`${styles.bar} ${styles.bar2}`} />
      <span className={`${styles.bar} ${styles.bar3}`} />
    </div>
  );
}
